import DevCard from '../components/DevCard';
import FilterBar from '../components/FilterBar';
import { useFilter } from '../hooks/useFilter';
import devPosts from '../data/devPosts';
import styles from './DevBlogPage.module.css';

export default function DevBlogPage() {
  const { filtered, category, setCategory, categories } =
    useFilter(devPosts, 'title', 'category');

  return (
    <div>
      <div className={styles.hero}>
        <div className="container">
          <div className={styles.heroInner}>
            <span className={styles.heroEmoji}>💻</span>
            <h1 className={styles.heroTitle}>Dev Blog</h1>
            <p className={styles.heroSub}>
              Real talk about working in tech - career tips, React deep-dives, tools & honest opinions.
            </p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <FilterBar categories={categories} active={category} onChange={setCategory} />
          </div>
        </div>
      </div>

      <div className={`container ${styles.gridWrap}`}>
        <div className="grid-3">
          {filtered.map((p, i) => (
            <DevCard key={p.id} post={p} style={{ animationDelay: `${i * 0.07}s` }} />
          ))}
        </div>
      </div>
    </div>
  );
}
